import React from 'react';

function CommentsLoader() {
    return <div className="post-comments-containers__loader">
        <span className="post-comments-containers__loader__text">LOADING</span>
    </div>
};

export default CommentsLoader;